module.exports = __webpack_public_path__ + "img/panda_theme_icon.391cdaf2.svg";